import {Injectable} from '@angular/core';
import * as _ from 'lodash';

@Injectable()
export class UtilsService {

  removeFromArray(array: any, object: any): any {
    const index = array.indexOf(object);
    if (index > -1) {
      array.splice(index, 1);
    }
    return array;
  }

  getCopyObject(myObject: any): any {
    return Object.assign({}, myObject);
  }

  isNotEqual(object: any, compareWith: any, fields: string[] = []): boolean {
    if (fields.length > 0) {
      let isNotEqual = false;
      fields.forEach(field => {
        if (_.isString(object[field]) && !this.controlDiffText(object[field], compareWith[field])) {
          isNotEqual = true;
          return;
        } else if (!_.isString(object[field]) && object[field] != compareWith[field]) {
          isNotEqual = true;
          return;
        }
      });
      return isNotEqual;
    }
    return !_.isEqual(object, compareWith);
  }

  controlDiffText(t1: string, t2: string): boolean {
    let test1 = t1;
    let test2 = t2;
    if (_.isUndefined(t1) || _.isNull(t1)) {
      test1 = '';
    }
    if (_.isUndefined(t2) || _.isNull(t2)) {
      test2 = '';
    }
    return test1.replace(' ', '').toLowerCase() ===
      test2.replace(' ', '').toLowerCase();
  }

  delay(ms: number): Promise<any> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  isInArrayString(array: Array<string>, match: string): boolean {
    return array.indexOf(match) > -1;
  }

  isInArray(array: Array<any>, index: string, match: string): boolean {
    let isIn = false;
    array.forEach(item => {
      if (item[index] === match) {
        isIn = true;
        return;
      }
    });
    return isIn;
  }

  isEmptyString(value: string | null | undefined): boolean {
    return !(value && value.length > 0);
  }

  copyToClipboard(inputElement): void {
    inputElement.select();
    document.execCommand('copy');
    inputElement.setSelectionRange(0, 0);
  }

  getOptionsFromAny(map: any): any[] {
    const options: any[] = [];
    for (const [key, value] of Object.entries(map)) {
      options.push({id: key, text: value});
    }
    return options;
  }

}
